import { getResources } from 'redux-resource';
import { getStatus }    from 'redux-resource';


export function getPayouts(state, businessID) {
  return getResources(state.payouts, businessID)[0];
}


export function getPayoutsStatuses(state, businessID) {
  return {
    createStatus:   {},
    deleteStatus:   {},
    readStatus:     getStatus(state.payouts, `requests.read-${businessID}.status`),
    readStatusCode: getPayoutsReadStatusCode(state, businessID),
    updateStatus:   {}
  };
}


function getPayoutsReadStatusCode(state, businessID) {
  return state.payouts.requests[`read-${businessID}`] ?
    state.payouts.requests[`read-${businessID}`].statusCode :
    null;
}
